import App from './App'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { suppressDefaultPropsWarnings } from './utils/suppressWarnings'

// Suppress defaultProps warnings from reactstrap components
suppressDefaultPropsWarnings()
const container = document.getElementById('root')
const root = createRoot(container!) // createRoot(container!) if you use TypeScript
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
